export enum TaskModalMode {
    EDITOR = 'editor',
    DETAILS = 'details',
}
